export default __webpack_public_path__ + "static/mainimg_sp-c5b9a88393e74a3368574fcd1a8d74cd.svg";